import useU2000AxiosNonAuthenticated from "../../axios/U2000UseAxiosNonAuthenticated";
import { useU2000AuthContext } from "../../context/auth/U2000UseAuthContext";

const LOGICALUNIT_URL = "U2001";
const REFRESHTOKEN_URL = LOGICALUNIT_URL + "/refreshToken";

type MenuType = any; // Remplacer par le type réel si connu
type RefreshTokenFn = (menu: MenuType) => Promise<any>; // Remplacer any par le type réel si connu

const useU2000RefreshToken = (): RefreshTokenFn => {
  const { refresh } = useU2000AuthContext();
  const u2000AxiosNonAuthenticated = useU2000AxiosNonAuthenticated();

  const doRrefreshToken: RefreshTokenFn = async (menu) => {
    try {
      const response = await u2000AxiosNonAuthenticated.get(REFRESHTOKEN_URL);
      return refresh(response.data, menu);
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  return doRrefreshToken;
};

export default useU2000RefreshToken;
